var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1253_1134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#19CF56",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4652 19.4877C42.219 17.2399 39.2322 16.0014 36.05 16C29.4925 16 24.1561 21.3347 24.1535 27.8919C24.1527 29.9879 24.7004 32.034 25.7413 33.8375L24.0536 40L30.3601 38.3464C32.0976 39.294 34.054 39.7933 36.0449 39.7941H36.0499H36.05C42.6064 39.7941 47.9437 34.4584 47.9464 27.9016C47.9475 24.7236 46.7112 21.7356 44.4652 19.4877ZM36.05 37.7855H36.0461C34.2716 37.7846 32.5314 37.3081 31.0135 36.4075L30.6523 36.1933L26.9099 37.1745L27.909 33.527L27.6737 33.1531C26.6838 31.5792 26.1613 29.7603 26.162 27.8927C26.1642 22.4426 30.5996 18.0087 36.0537 18.0087C38.6949 18.0098 41.1773 19.0393 43.0443 20.9075C44.9112 22.7758 45.9385 25.2594 45.9377 27.9007C45.9354 33.351 41.4998 37.7855 36.05 37.7855Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5997 39.3163L26.2104 33.4353C25.2167 31.7141 24.6942 29.7614 24.6948 27.7615C24.6974 21.504 29.7901 16.4131 36.0475 16.4131C39.0845 16.4145 41.9349 17.5964 44.0781 19.7415C46.2216 21.8866 47.4014 24.738 47.4002 27.7704C47.3976 34.0281 42.3045 39.1194 36.048 39.1194C36.0475 39.1194 36.0483 39.1194 36.048 39.1194H36.0429C34.143 39.1188 32.2761 38.6419 30.618 37.7382L24.5997 39.3163Z",
    fill: "url(#paint0_linear_1253_1134)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1102 22.8432C32.8901 22.3539 32.6584 22.3441 32.449 22.3355C32.2777 22.3282 32.0817 22.3286 31.8859 22.3286C31.69 22.3286 31.3716 22.4022 31.1024 22.6963C30.833 22.9903 30.0739 23.7011 30.0739 25.1467C30.0739 26.5925 31.1269 27.9895 31.2737 28.1857C31.4206 28.3817 33.3065 31.4432 36.2931 32.6209C38.7753 33.5998 39.2804 33.4051 39.8191 33.3561C40.3579 33.3071 41.5576 32.6454 41.8025 31.9593C42.0474 31.2732 42.0474 30.6852 41.9739 30.5623C41.9004 30.4398 41.7045 30.3664 41.4106 30.2194C41.1168 30.0725 39.6722 29.3615 39.4028 29.2636C39.1334 29.1656 38.9375 29.1166 38.7416 29.4108C38.5457 29.7047 37.9829 30.3664 37.8114 30.5623C37.64 30.7586 37.4686 30.7831 37.1747 30.6362C36.8808 30.4888 35.9345 30.1788 34.8118 29.1778C33.9383 28.3991 33.3485 27.4372 33.1771 27.1431C33.0057 26.8492 33.1587 26.69 33.3062 26.5435C33.4381 26.4119 33.6 26.2005 33.747 26.0289C33.8936 25.8574 33.9426 25.7349 34.0405 25.539C34.1385 25.3428 34.0895 25.1712 34.016 25.0243C33.9426 24.8773 33.3715 23.4242 33.1102 22.8432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3681 19.4499C42.1477 17.2279 39.1952 16.0036 36.0495 16.0022C29.5673 16.0022 24.2921 21.2757 24.2895 27.7576C24.2888 29.8296 24.8301 31.8521 25.8591 33.6349L24.1908 39.7267L30.4249 38.092C32.1425 39.0287 34.0764 39.5223 36.0445 39.5231H36.0495H36.0495C42.5306 39.5231 47.8066 34.2487 47.8094 27.7671C47.8104 24.6257 46.5883 21.672 44.3681 19.4499ZM36.0495 37.5376H36.0457C34.2915 37.5367 32.5713 37.0658 31.0708 36.1754L30.7137 35.9637L27.0143 36.9337L28.002 33.328L27.7693 32.9584C26.7908 31.4026 26.2742 29.6046 26.275 27.7584C26.2771 22.3709 30.6617 17.9878 36.0532 17.9878C38.6641 17.9889 41.1179 19.0066 42.9635 20.8534C44.809 22.7002 45.8245 25.1553 45.8237 27.7664C45.8214 33.154 41.4367 37.5376 36.0495 37.5376Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1253_1134",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1253_1134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1253_1134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1253_1134",
    x1: 36,
    y1: 39.3163,
    x2: 36,
    y2: 16.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8944,
    height: 24,
    fill: "white",
    transform: "translate(24.0529 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.4b8a5e0be19a7a008bcb12b4d7226c8a.svg";
export { ForwardRef as ReactComponent };